import { el } from "./dom";

// The drawer's Credits section — realizes the in-bundle attribution obligations for
// third-party assets + the runtime dep (see docs/attribution.md). Songs carry their
// own per-song credit (shown when loaded); this covers everything else baked in.

function link(href: string, text: string): HTMLAnchorElement {
  return el<HTMLAnchorElement>("a", {
    href,
    target: "_blank",
    rel: "noopener noreferrer",
    textContent: text,
  });
}

/** A "Credits" heading + the credit lines, ready to splice into the drawer. */
export function buildCredits(): HTMLElement[] {
  const wrap = el("div", { class: "credits" });

  const clefs = el("p");
  clefs.append(
    "Clefs — bass clef (FClef) by Wikimedia user っ, ",
    link("https://creativecommons.org/licenses/by-sa/3.0/", "CC BY-SA 3.0"),
    " (unmodified); treble clef (GClef), public domain. ",
    link("https://commons.wikimedia.org/wiki/File:FClef.svg", "source"),
  );

  const midi = el("p");
  midi.append("MIDI parsing — ", link("https://github.com/Tonejs/Midi", "@tonejs/midi"), ", MIT.");

  const songs = el("p", {
    textContent:
      "Songs — Mutopia Project (PD / CC-BY-SA); per-song credit shows above when a song is loaded.",
  });

  wrap.append(clefs, midi, songs);
  return [el("h3", { textContent: "Credits" }), wrap];
}
